import {useMemo} from 'react';
import {getId} from 'services/utils';

export const useUniqueFieldId = (name: string): string => {
  return useMemo(() => {
    const id = getId();
    return `${id}:${name}`;
  }, [name]);
};
